import React from 'react';
import ZteWireless from '../../../assets/images/zte_wireless.png'
import Cobertura from "../../../assets/images/areaCobertura.png";
import Controller from "../../../assets/images/controller.png";
import UnionWifi from "../../../assets/images/unionWifi.png";
import SegundoRouter from "../../../assets/images/segundoRouter.png";
import Topologia from "../../../assets/images/topologia.png";
import Mesh from "../../../assets/images/mesh.gif";
import Eye from "../../../assets/images/eyes.gif";

import './styles.css';

const ModoMesh = () => {


    return (
        <>
            <div className="mesh-title">
                <h1>Conhecendo a Tecnologia Mesh</h1><br />
                <h4>
                    Redes Mesh WiFi: o que são, como funcionam e por que podem melhorar sua rede WiFi em casa
                </h4>
                <p>
                    As redes mesh, também conhecidas como redes em malha, são uma topologia de rede que se diferencia das
                    redes tradicionais em estrela ou barramento. Elas são projetadas para oferecer maior flexibilidade,
                    confiabilidade e alcance em comparação com as topologias de rede convencionais.
                    Aqui estão algumas informações importantes sobre redes mesh:
                </p>
                <p>
                    <strong>1. Topologia em Malha:</strong> Nas redes mesh, todos os dispositivos estão interconectados, formando uma malha de
                    conexões. Isso significa que cada dispositivo na rede pode se comunicar diretamente com outros
                    dispositivos, eliminando a necessidade de um único ponto central de controle.
                    Essa topologia distribuída permite maior robustez e redundância.
                </p>
                <p>
                    <strong>2. Redundância e Confiabilidade:</strong> A principal vantagem das redes mesh é a redundância. Como cada
                    dispositivo pode se comunicar com vários outros, se um nó falhar ou a conexão for perdida, os
                    dados podem ser roteados por caminhos alternativos. Isso torna as redes mesh altamente confiáveis,
                    pois são menos suscetíveis a falhas devido a problemas em um único ponto.
                </p>
                <p>
                    <strong>3. Autoconfiguração:</strong> As redes mesh geralmente são autoconfiguráveis, o que significa que os dispositivos
                    podem ser facilmente adicionados ou removidos da rede sem a necessidade de uma configuração manual
                    complexa. Os dispositivos na rede "conversam" entre si para determinar a melhor rota de comunicação.
                </p>
                <p>
                    <strong>4. Cobertura Estendida:</strong> Devido à sua topologia em malha e capacidade de encaminhamento de dados através
                    de múltiplos saltos, as redes mesh são ideais para estender a cobertura de rede em
                    áreas grandes ou em ambientes com obstáculos físicos, como paredes grossas.
                </p>
                <p>
                    <strong>5. Aplicações:</strong> As redes mesh são frequentemente usadas em ambientes domésticos para estender a
                    cobertura Wi-Fi, em ambientes empresariais para criar redes escaláveis e confiáveis e em
                    cenários de infraestrutura de rede em cidades inteligentes e IoT (Internet das Coisas).
                </p>
                <p>
                    <strong>6. Padrões e Protocolos:</strong> Existem vários padrões e protocolos que suportam redes mesh, como o IEEE 802.11s
                    para Wi-Fi mesh e o Zigbee e Z-Wave para redes de sensores sem fio.
                    Cada um desses padrões é adequado para diferentes tipos de aplicações.
                </p>
                <p>
                    <strong>7. Segurança:</strong> A segurança em redes mesh é uma consideração importante, uma vez que os dispositivos estão
                    interconectados. É essencial implementar protocolos de segurança, como criptografia,
                    autenticação e controle de acesso, para proteger os dados transmitidos na rede.
                </p>
                <p>
                    Em resumo, as redes mesh oferecem uma solução versátil e confiável para cenários em que a cobertura de
                    rede estendida, a confiabilidade e a escalabilidade são essenciais. Elas são usadas em uma variedade
                    de contextos, desde melhorar a conectividade Wi-Fi
                    em casa até suportar infraestruturas complexas de cidades inteligentes e IoT.
                </p>
                <br />
                <h1>
                    Vamos analizar o cenário a seguir
                </h1>
                <br />
                <h4>
                    Em um cenário real utilize o aplicativo <a href='https://play.google.com/store/apps/details?id=com.farproc.wifi.analyzer&hl=pt_BR&gl=US' about='_blank'>Wifi Analyzer</a> para identificar as áreas ideais de posicionamento dos roteadores, garantindo uma cobertura de sinal conforme desejado.

                </h4>
                <span>
                    Observe os círculos em verde para visualisar a área de cobertura do sinal de cada roteador:
                </span>
                <div className="mesh-gif">
                    <div className='cobertura'>
                        <img src={Cobertura} alt="mesh" />
                        <h5>
                            Podemos concluir, pela figura acima, que apenas o primeiro roteador não é
                            capaz de fornecer um sinal eficiente para toda a casa. Portanto, a solução ideal,
                            nesse cenário, seria adicionar mais dois roteadores
                            para garantir uma cobertura de sinal adequada em todo o ambiente.<br /><br />
                            Com o Wi-Fi Mesh toda a sua casa fica coberta pelo sinal Wi-Fi e você consegue navegar 
                            na internet até naqueles cômodos mais distantes.
                        </h5>
                        <p>
                            Uma rede Wifi em malha, ou mesh, consiste em um roteador controlador (Controller Router) e seus
                            satélites (Agent) ou pontos de acesso que se comunicam para criar uma única rede Wifi com o mesmo
                            SSID e senha para o usuário. À medida que o usuário se desloca pelo ambiente de cobertura,
                            a transição de conexão ocorre de maneira transparente, conectando-se ao roteador mais próximo.
                        </p>
                    </div>
                    <div className='cobertura'>
                        <img src={Mesh} alt='mesh' />
                    </div>
                    <p>
                    Embora à primeira vista possam parecer semelhantes aos roteadores tradicionais com vários repetidores, 
                    as redes de malha Wifi têm uma diferença fundamental. Ao contrário dos repetidores convencionais, 
                    o destaque está no gerenciamento inteligente de todos os elementos da rede, tráfego e a situação do ambiente. 
                    
                    </p>
                    <span>
                        Obs.  Para garantir uma conexão estável, é altamente recomendável que todos os roteadores 
                        estejam interconectados por meio de cabos de rede. Isso proporciona uma redundância significativa; se um cabo falhar, o roteador 
                        ainda pode se conectar à rede por meio da conexão WiFi, embora haja uma breve interrupção até o alinhamento e perda de desempenho em comparação com a rede cabeada.
                    </span>
                    <br /><br />
                </div>
            </div>
            <hr />
            <div className="mesh">

                <h1>Configurando uma rede Mesh utilizando dois roteadores ZTE</h1><br /><br />
                <h4>
                    Configure a rede Wifi com o nome e senha desejado.
                </h4>
                <img src={ZteWireless} alt='zte' />

                <h4>Nessa mesma página configure a opção mostrada na figura abaixo, essa opção serve para juntar as configurações da rede 2.4GHz com a 5GHz. É importante que elas tenha o mesmo nome e senha. </h4>
                <img src={UnionWifi} alt='zte' />

                <h4>
                    Para configurar a rede Mesh, clique em Gerenciamento & Diagnóstico na barra
                    superior e na coluna à esquerda em Work Mode.
                </h4>
                <img src={Controller} alt='controller' />
            </div>
            <p>
                As principais configurações no roteador principal (Controller Router) já foram realizadas, vamos pro segundo roteador, dessa vez o Agent.
            </p>

            <div className="mesh">
                <h1>Veja como é fácil adicionar o segundo e outros roteadores à rede Mesh (Malha).</h1>
                <h4>Conecte o cabo Ethernet na WAN do segundo roteador com a LAN do primeiro </h4>
                <h4>
                    Acesse o segundo roteador com outro cabo Ethernet na LAN configure a opção abaixo:
                </h4>
                <img src={SegundoRouter} alt='router' />
                <h4>Simples assim,  repita esse último processo para adicionar mais roteadores.</h4>
            </div>
            <div className="mesh">
                <h4>Para verificar se tudo deu certo, volte ao primeiro roteador (Controller) e acesse: </h4>
                <img src={Topologia} alt='router' />
                <div className="mesh-finally">
                    <h3>O segundo roteador já está na rede.</h3> <img src={Eye} alt='eye' />
                </div>
                <p>
                    Observação: Outras opções de configuração para uma rede Mesh serão compartilhadas neste espaço.
                </p>
            </div>





        </>
    );
};

export default ModoMesh;
